/**
 * If you want to use your local WP install (art-direction-show.ups.dock)
 * for content, set the DEV_MODE constant below to 'true'.
 */
const DEV_MODE = false;

export const IS_PROD =
  process.env.REACT_APP_CONTEXT === 'production' || process.env.REACT_APP_BRANCH === 'main';

const LOCAL_API_URL = 'http://art-direction-show.ups.dock';
const LIVE_API_URL = IS_PROD
  ? 'https://api.artdirection.show'
  : 'https://test-art-direction-show.pantheonsite.io';

export const API_URL = `${DEV_MODE ? LOCAL_API_URL : LIVE_API_URL}/wp-json`;
